import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/career-change-assessment/CareerChangeContent.tsx");
